import { UseQueryResult } from "@tanstack/react-query";

export const extractQueryState = <T extends UseQueryResult>(query: T): T => {
  return {
    ...query,
  };
};
